// Designed for user with user media that uses UUIDs as extensions
export default x => /\.([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/.test(x || '') ? x.slice(0, -37) : x;
